<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <input class="form-control"
                       placeholder="ค้นหาชื่อ/เลขผู้เสียภาษี"
                       type="text"
                       v-model="search.tax"/>
                &nbsp;
                <button @click="getData(1)"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    ค้นหา
                </button>
                &nbsp;
                <button @click="createCustomer()"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="plus"></icon>
                    สร้างผู้เสียภาษี
                </button>
            </div>
            <br/>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>ชื่อ</th>
                    <th>เลขภาษี</th>
                    <th>จัดการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="x in taxCustomerList">
                    <td>{{x.name}}</td>
                    <td>{{x.tax_number}}</td>
                    <td>
                        <button @click="updateById(x.id)"
                                class="btn btn-primary"
                                type="button">
                        แก้ไข
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="Paginate"
                        @paginate="getData(Paginate.current_page)"
        >

        </vue-pagination>
    </div>
</template>

<script>
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";
import {mapState} from "vuex";

export default {
        name: "CreditNoteList",
        components :{VuePagination,Loading},
        data(){
          return{
              status_loading : 1,
              msg : '',
              search : {
                  tax : ''
              }
          }
        },
        computed:{
            ...mapState({
                taxCustomerList :state=>{
                    return state.TaxInvoice.tax_customer_info_list
                },
                Paginate :state=>{
                    return state.TaxInvoice.pagination
                },
            })
        },
        created() {
            this.getData(1)
        },
        methods:{
            // this.status_loading = 3;
            // this.msg = 'ออกเอกสารไม่สำเร็จ';
            createCustomer(){
                this.$router.push('/accounting/tax-customer-form-create/null')
            },
            getData(page){
                let data = {
                    page : page,
                    tax : this.search.tax
                }
                this.$store.dispatch("TaxInvoice/getTaxCustomerInfo",data)
            },
            updateById(id) {
                this.$router.push({
                    path: '/accounting/tax-customer-form-create/'+id
                });
            }
        },
    }
</script>

<style scoped>
    .select{
        border:0
    }
</style>
